// src/components/PatientPortal/InviteList/InviteList.jsx
import React from "react";
import { Table, Space, Tooltip, Tag } from "antd";
import dayjs from "dayjs";
import RevokeInvite from "../RevokeInvite/RevokeInvite";
import ResendInvite from "../ResendInvite/ResendInvite";

const InviteList = ({ invites, page, pageSize, total, setPage, setPageSize, reload, setPageLoading }) => {
  const columns = [
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Created",
      dataIndex: "created_at",
      key: "created_at",
      render: (d) => dayjs(d).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "Expires",
      dataIndex: "expires_at",
      key: "expires_at",
      render: (d) => dayjs(d).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => (
        <Space>
          {!record.revoked ? <Tag color="green">Active</Tag> : <Tag color="red">Revoked</Tag>}
          {record.used && <Tag color="blue">Used</Tag>}
        </Space>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Resend Invite">
            <ResendInvite
              patientId={record.patient_id}
              inviteId={record.invite_id}
              reload={reload}
              setPageLoading={setPageLoading}
            />
          </Tooltip>
          <Tooltip title="Revoke Invite">
            <RevokeInvite
              inviteId={record.invite_id}
              patientId={record.patient_id}
              reload={reload}
              setPageLoading={setPageLoading}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <Table
      rowKey="invite_id"
      columns={columns}
      dataSource={invites}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: true,
        onChange: (p, ps) => {
          setPage(p);
          setPageSize(ps);
        },
      }}
    />
  );
};

export default InviteList;
